<template>
  <div class="bg">
    <v-row justify="center">
      <div class="white-card pa-8">
        <v-row justify="center">
          <img height="150px" class="my-8" src="../assets/images/logo.png" alt="" />
        </v-row>
        <v-row justify="center">
          <p class="welcome-text fs400">WELCOME TO</p>
        </v-row>
        <v-row class="ma-0" justify="center">
          <h1 class="blue-color text-center mt-4">LOTUS LIFE DASHBOARD</h1>
        </v-row>
        <v-row justify="center">
          <p class="info-text fs700">DOCTOR/CLIENT MANAGEMENT SYSTEM</p>
        </v-row>
        <v-row justify="center">
          <p class="welcome-text fs400 mt-8">FORGOT YOUR PASSWORD?</p>
        </v-row>
        <v-row justify="center" class="ma-0">
          <v-text-field ref="email" dense filled rounded label="Email Address" class="mt-4" v-model="email" required
            :rules="emailRules"></v-text-field>
        </v-row>
        <v-row class="ma-0" justify="center">
          <v-btn @click="resetPassword()" color="#e022d1" dark rounded width="240px" class="pink-btn">
            SEND RESET EMAIL
          </v-btn>
        </v-row>
        <v-row justify="center">
          <h4 @click="$router.push('/')" class="black-color mt-4 pointer">
            Back
          </h4>
        </v-row>
      </div>
    </v-row>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="black" dark depressed large style="border-radius: 24px" @click="promptDialog = false">
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      email: null,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      loading: false,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
    };
  },
  methods: {
    resetPassword() {
      let emailValid = this.$refs.email.validate();

      if (!emailValid) {
        this.promptMessage = "Please enter a valid email address!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.loading = true;

      sendPasswordResetEmail(auth, this.email)
        .then((userCredential) => {
          this.loading = false;
          this.promptMessage = "Password reset email successfully sent! Please check your spam folder as well.";
          this.promptType = "success";
          this.promptDialog = true;

          setTimeout(() => {
            this.promptDialog = false;
            this.$router.push("/");
          }, 3000);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;

          if (
            error == "FirebaseError: Firebase: Error (auth/user-not-found)."
          ) {
            this.promptMessage =
              "Email not found , please try a different email address!";
            this.promptType = "error";
            this.promptDialog = true;
          } else {
            this.promptMessage =
              "An error occured while sending the password reset email, please try again!";
            this.promptType = "error";
            this.promptDialog = true;
          }
        });
    },
  },
};
</script>

<style scoped>
.bg {
  width: 100%;
  height: 102vh;
  background-image: url("../assets/images/background.png");
  background-size: cover;
}

.white-card {
  width: 500px;
  max-width: 80%;
  border-radius: 0px 0px 25px 25px;
  box-shadow: 1px 1px 4px grey;
  background-color: white;
}

.text-center {
  text-align: center;
}

.welcome-text {
  font-size: 25px;
  font-weight: 300;
}

.info-text {
  font-size: 16px;
  font-weight: 400;
}

.input {
  width: 250px !important;
}
</style>